import { useState, useEffect } from 'react';
import { useToggle, } from 'react-use';

export default function useCollectionFetch (ref, dependencies = [], { initialItems = [], detail = false, } = {}) {
  const [items, setItems] = useState(initialItems);
  const [isLoading, toggleLoading] = useToggle(false);
  useEffect(() => {
    if(!ref) return setItems([]);

    let cleanedUp = false;
    toggleLoading(true);
    ref
      .get()
      .then(({ docs }) => {
        if(!cleanedUp) {
          setItems(docs.map(_ => ({ id: _.id, ref: _.ref, ..._.data() })));
        }
        toggleLoading(false);
      });

    return _ => cleanedUp = true;
  }, dependencies);
  return detail ? { items, isLoading } : items;
};
